// extracted by mini-css-extract-plugin
module.exports = {"ProjectTechIcon":"ProjectTechIcon_ProjectTechIcon__31Ww8"};